import { render, staticRenderFns } from "./PageBoard.vue?vue&type=template&id=02cf42ca&scoped=true&"
import script from "./PageBoard.vue?vue&type=script&lang=js&"
export * from "./PageBoard.vue?vue&type=script&lang=js&"
import style0 from "./PageBoard.vue?vue&type=style&index=0&id=02cf42ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!//node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf42ca",
  null
  
)

export default component.exports